export const COUNTRIES_COUNT = 8;
